import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';

import { UserState } from '@app/auth/user.state';
import { BootstrapSuffix } from '@app/common.model';
import { ToastService } from '@app/toasts/toast.service';

/**
 * Route guard that allows activation only for Copado Admins.
 *
 * A Copado Admin is a user who has either the `superAdmin` or `provisioningAdmin` flag.
 *
 * @returns {boolean} `true` if the current user is a Copado Admin, otherwise `false`.
 */
export const copadoAdminGuard: CanActivateFn = (): boolean => {
  const toastService = inject(ToastService);
  const user = inject(UserState).user();

  if (!user) return false;

  if (user.superAdmin || user.provisioningAdmin) {
    return true;
  }

  if (!user.superAdmin && !user.provisioningAdmin) {
    toastService.displayToast(
      BootstrapSuffix.Danger,
      $localize`No permissions to view this.`,
      $localize`Auth error`,
    );
    return false;
  }

  return true;
};
